import React from 'react'
import { Grid } from '@mui/material'

import { MessageBoardPartner } from './MessageBoardPartner'
import { Partner } from './messageBoard.types'

type Props = {
  partners: Partner[] | null | undefined
  selectedPartnerId: string | undefined
  onSelectPartner?: (partner: Partner) => void
}

const MessageBoardPartners: React.FC<React.PropsWithChildren<Props>> = ({
  partners,
  selectedPartnerId,
  onSelectPartner,
}) => {
  return (
    <>
      <Grid container spacing={1} direction="column" alignItems="stretch">
        {partners &&
          partners.map((partner) => (
            <Grid item key={partner.id} xs={12}>
              <MessageBoardPartner
                partner={partner}
                isSelected={partner.id === selectedPartnerId}
                onClick={() => {
                  onSelectPartner && onSelectPartner(partner)
                }}
              />
            </Grid>
          ))}
      </Grid>
    </>
  )
}

export { MessageBoardPartners }
